export const webviewNamespace = 'WebviewApp';
